<template>
    <div>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="668.9px" height="429px" viewBox="0 0 668.9 429" style="enable-background:new 0 0 668.9 429;"
            xml:space="preserve">
            <g id="Capa_2">
            </g>
            <g id="pantalla_0">
            </g>
            <g id="pantalla__4">
            </g>
            <g id="pantalla_4">
                <rect id="XMLID_2556_" x="544.3" y="238" class="st226" width="129.3" height="186" />
                <g id="XMLID_2575_">
                    <line id="XMLID_52_" class="st328" x1="58.9" y1="148.7" x2="610" y2="148.7" />
                    <g id="XMLID_2547_">
                        <g id="XMLID_2752_">
                            <g id="XMLID_2758_">
                                <line id="XMLID_2759_" class="st213" x1="233.7" y1="169.8" x2="435.2" y2="169.8" />
                            </g>
                            <polyline id="XMLID_2754_" class="st213" points="425.3,161.5 436.5,169.9 425.3,178 				" />
                            <polyline id="XMLID_2753_" class="st213" points="243.6,161.5 232.4,169.9 243.6,178 				" />
                        </g>
                    </g>
                    <g id="XMLID_2576_">
                        <g id="XMLID_2741_">
                            <g id="XMLID_2743_">
                                <line id="XMLID_2748_" class="st212" x1="187.9" y1="80.3" x2="223.6" y2="116" />
                            </g>
                            <polyline id="XMLID_2742_" class="st212"
                                points="222.8,107.4 224.2,116.7 215.1,115.2 				" />
                        </g>
                    </g>
                    <g id="XMLID_2577_">
                        <g id="XMLID_2729_">
                            <g id="XMLID_2737_">
                                <line id="XMLID_2738_" class="st212" x1="480.5" y1="80.3" x2="444.8" y2="116" />
                            </g>
                            <polyline id="XMLID_2736_" class="st212"
                                points="445.6,107.4 444.2,116.7 453.3,115.2 				" />
                        </g>
                    </g>
                    <line id="XMLID_2555_" class="st62" x1="226.6" y1="119.3" x2="226.6" y2="193" />
                    <line id="XMLID_2557_" class="st62" x1="440.7" y1="119.3" x2="440.7" y2="193" />
                    <g id="XMLID_2560_">
                        <rect id="XMLID_1139_" x="168" y="63.9" class="st226" width="33.5" height="14.5" />
                        <text transform="matrix(1 0 0 1 171.5928 75.9121)" class="st102 st273">LEL </text>
                    </g>
                    <g id="XMLID_2562_">
                        <rect id="XMLID_1137_" x="250.1" y="178" class="st226" width="168.8" height="15" />
                        <text transform="matrix(1 0 0 1 260.5684 190.0474)" class="st102 st273">Explosión /
                            Incendio</text>
                    </g>
                    <g id="XMLID_2565_">
                        <rect id="XMLID_1133_" x="58.9" y="158" class="st226" width="116" height="26.6" />
                        <text transform="matrix(1 0 0 1 58.9395 170.0122)">
                            <tspan x="0" y="0" class="st102 st273">Concentración </tspan>
                            <tspan x="0" y="14" class="st102 st273">de sustancia</tspan>
                        </text>
                    </g>
                    <g id="XMLID_2571_">
                        <rect id="XMLID_1126_" x="464.3" y="64.9" class="st226" width="32.5" height="13.5" />
                        <text transform="matrix(1 0 0 1 466.1016 76.8882)" class="st102 st273">UEL </text>
                    </g>
                    <g id="XMLID_2552_">
                        <g id="XMLID_2580_">
                            <path id="XMLID_2623_" class="st78" d="M119.6,135.3c6.5,4.5,14.3,5,21.9,5.6c9,0.8,18.1,1.4,27.2,1.3
					c16.3-0.2,32.8-3.1,46.7-12c13.5-8.7,23.1-22,30.6-35.9c8.7-16.2,13.5-35,24.5-49.8c10.8-14.6,27.7-23,44.9-27.6
					c19.4-5.2,41.4-8.8,59.7,1.4c7.4,4.1,15.8,9.2,21.6,15.4c6.8,7.4,8.8,18.3,12.2,27.4c7,18.5,15.4,37.2,26.2,53.8
					c9.5,14.6,23.2,26.1,41.2,27.2c11.2,0.7,22.6-0.1,33.9-0.3c12.4-0.2,24.8-0.5,37.2-0.7c0.9,0,3.1-1.4,1.2-1.3
					c-21.2,0.4-42.3,0.9-63.5,1.2c-10.6,0.1-20.4-1.7-29.3-7.8c-6.8-4.7-12.4-11-17-17.8c-10.7-15.8-18.9-33.8-25.8-51.6
					c-3.4-8.7-5.4-18.6-10.3-26.5c-4.3-7.1-11.8-11.6-18.6-16.1c-7-4.6-14.4-8.7-22.7-10.1c-8.3-1.5-16.9-0.6-25.2,0.5
					c-14.8,2-29.7,5.6-43.1,12.4c-14.1,7.1-25,17.7-32.2,31.8c-7.9,15.5-13.3,32.2-22.5,47.1c-11.6,18.7-28,32.6-50.2,36.5
					c-11.4,2-23.1,1.8-34.6,1c-10.2-0.7-22.7-0.2-31.4-6.2C121.6,133.7,119.1,134.9,119.6,135.3L119.6,135.3z" />
                        </g>
                    </g>
                </g>
                <g id="XMLID_146_">
                    <rect id="XMLID_2846_" x="251.5" y="256.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2845_" x="251.5" y="288.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2844_" x="251.5" y="320.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2842_" x="251.5" y="352.5" class="st73" width="166" height="32" />
                    <rect id="XMLID_2837_" x="251.5" y="221.5" class="st75" width="166" height="35" />
                    <rect id="XMLID_2836_" x="417.5" y="256.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2835_" x="417.5" y="288.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2834_" x="417.5" y="320.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2833_" x="417.5" y="352.5" class="st73" width="166" height="32" />
                    <rect id="XMLID_2829_" x="417.5" y="221.5" class="st75" width="166" height="35" />
                    <g id="XMLID_2819_">
                        <rect id="XMLID_1096_" x="265.5" y="232.6" class="st226" width="137" height="15.5" />
                        <text transform="matrix(1 0 0 1 320.9346 244.6479)" class="st102 st273">LEL</text>
                    </g>
                    <g id="XMLID_2811_">
                        <rect id="XMLID_1040_" x="433" y="232.6" class="st226" width="137" height="15.5" />
                        <text transform="matrix(1 0 0 1 487.1348 244.6479)" class="st102 st273">UEL</text>
                    </g>
                    <g id="XMLID_2795_">
                        <rect id="XMLID_1034_" x="301.1" y="265.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 316.4727 277.8745)" class="st120 st273">1,4%</text>
                    </g>
                    <g id="XMLID_2787_">
                        <rect id="XMLID_1018_" x="468.6" y="265.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 483.9727 277.8745)" class="st120 st273">7,6%</text>
                    </g>
                    <g id="XMLID_2782_">
                        <rect id="XMLID_996_" x="301.1" y="296.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 316.4727 308.8745)" class="st120 st273">4,0%</text>
                    </g>
                    <g id="XMLID_2775_">
                        <rect id="XMLID_994_" x="468.6" y="296.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 479.748 308.8745)" class="st120 st273">14,0%</text>
                    </g>
                    <g id="XMLID_2769_">
                        <rect id="XMLID_984_" x="301.1" y="328.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 316.4727 340.8745)" class="st120 st273">2,0%</text>
                    </g>
                    <g id="XMLID_2756_">
                        <rect id="XMLID_983_" x="468.6" y="328.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 479.748 340.8745)" class="st120 st273">15,0%</text>
                    </g>
                    <g id="XMLID_2745_">
                        <rect id="XMLID_761_" x="301.1" y="360.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 316.4727 372.8745)" class="st120 st273">2,0%</text>
                    </g>
                    <rect id="XMLID_2800_" x="85.4" y="256.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2797_" x="85.4" y="288.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2785_" x="85.4" y="320.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2784_" x="85.4" y="352.5" class="st73" width="166" height="32" />
                    <rect id="XMLID_2772_" x="85.4" y="221.5" class="st75" width="166" height="35" />
                    <g id="XMLID_2730_">
                        <rect id="XMLID_742_" x="135.5" y="265.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 136.6777 277.7729)" class="st102 st273">Gasolina</text>
                    </g>
                    <g id="XMLID_2695_">
                        <rect id="XMLID_741_" x="135.5" y="296.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 140.8848 308.7729)" class="st102 st273">Metano</text>
                    </g>
                    <g id="XMLID_2617_">
                        <rect id="XMLID_565_" x="135.5" y="328.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 143.1289 340.7729)" class="st102 st273">ACPM0 </text>
                    </g>
                    <g id="XMLID_2579_">
                        <rect id="XMLID_564_" x="125.7" y="360.8" class="st226" width="85.4" height="15.5" />
                        <text transform="matrix(1 0 0 1 134.0938 372.7729)" class="st102 st273">Acetileno</text>
                    </g>
                    <g id="XMLID_2727_">
                        <rect id="XMLID_524_" x="468.6" y="360.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 479.748 372.8745)" class="st120 st273">81,0%</text>
                    </g>
                    <rect id="XMLID_2746_" x="251.5" y="384.5" class="st10" width="166" height="32" />
                    <rect id="XMLID_2619_" x="417.5" y="384.5" class="st10" width="166" height="32" />
                    <g id="XMLID_376_">
                        <rect id="XMLID_526_" x="301.1" y="392.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 316.4727 404.8745)" class="st120 st273">7,0%</text>
                    </g>
                    <rect id="XMLID_375_" x="85.4" y="384.5" class="st10" width="166" height="32" />
                    <g id="XMLID_342_">
                        <rect id="XMLID_527_" x="125.7" y="392.8" class="st226" width="85.4" height="15.5" />
                        <text transform="matrix(1 0 0 1 146.1543 404.7729)" class="st102 st273">Crudo</text>
                    </g>
                    <g id="XMLID_336_">
                        <rect id="XMLID_528_" x="468.6" y="392.8" class="st226" width="65.8" height="15.5" />
                        <text transform="matrix(1 0 0 1 479.748 404.8745)" class="st120 st273">15,0%</text>
                    </g>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
    import nextConditions from "../../../js/mixins/nextConditions";
    export default {
        mixins: [nextConditions],
        data() {
            return {
                visto: false,
                modala: false,
            }
        },
        methods: {},
        mounted() {},
    }
</script>


<style lang="scss" scoped>
    .st0 {
        fill: none;
        stroke: url(#XMLID_2474_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st1 {
        fill: #46535B;
    }

    .st2 {
        fill: none;
        stroke: url(#XMLID_2432_);
        stroke-miterlimit: 10;
    }

    .st3 {
        fill: none;
        stroke: url(#XMLID_2479_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st4 {
        fill: none;
        stroke: url(#XMLID_2435_);
        stroke-miterlimit: 10;
    }

    .st5 {
        fill: none;
        stroke: url(#XMLID_2700_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st6 {
        fill: #ABBFC6;
    }

    .st7 {
        fill: #AC7B63;
    }

    .st8 {
        fill: #105477;
    }

    .st9 {
        fill: #106489;
    }

    .st10 {
        fill: none;
        stroke: #23CAD9;
        stroke-width: 0.5;
        stroke-miterlimit: 10;
    }

    .st11 {
        fill: #E0B192;
    }

    .st12 {
        fill: #E0E2DE;
    }

    .st13 {
        fill: none;
        stroke: #353535;
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st14 {
        fill: #132C33;
    }

    .st15 {
        fill: #E1E1E1;
    }

    .st16 {
        clip-path: url(#XMLID_111_);
    }

    .st17 {
        fill: none;
        stroke: url(#XMLID_2676_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st18 {
        fill: url(#XMLID_2442_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st19 {
        fill: none;
        stroke: url(#XMLID_2679_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st20 {
        fill: url(#XMLID_2591_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st21 {
        fill: #32ADF0;
        stroke: #32ADF0;
        stroke-width: 11;
        stroke-miterlimit: 10;
    }

    .st22 {
        fill: none;
        stroke: #1D1D1B;
        stroke-miterlimit: 10;
    }

    .st23 {
        clip-path: url(#XMLID_3061_);
    }

    .st24 {
        clip-path: url(#XMLID_3094_);
    }

    .st25 {
        fill: url(#XMLID_2630_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st26 {
        fill: #4C4C4C;
    }

    .st27 {
        fill: #E89C2E;
    }

    .st28 {
        fill: #E8B897;
    }

    .st29 {
        fill: url(#XMLID_2639_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st30 {
        filter: url(#Adobe_OpacityMaskFilter);
    }

    .st31 {
        fill: none;
        stroke: url(#XMLID_2493_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st32 {
        fill: none;
        stroke: url(#XMLID_2496_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st33 {
        fill: #B0D882;
    }

    .st34 {
        fill: none;
        stroke: url(#XMLID_2688_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st35 {
        fill: none;
        stroke: url(#XMLID_2689_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st36 {
        fill: none;
        stroke: url(#XMLID_2861_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st37 {
        fill: none;
        stroke: url(#XMLID_3040_);
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .st38 {
        fill: none;
        stroke: url(#XMLID_2863_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st39 {
        fill: none;
        stroke: url(#XMLID_2866_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st40 {
        fill: none;
        stroke: url(#XMLID_2728_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st41 {
        fill: #B4754D;
    }

    .st42 {
        fill: url(#XMLID_2640_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st43 {
        fill: #28F7D1;
        stroke: #23CAD9;
        stroke-width: 0.5;
        stroke-miterlimit: 10;
    }

    .st44 {
        fill: #B4B4B4;
    }

    .st45 {
        fill: #B50D3D;
    }

    .st46 {
        opacity: 0.17;
        fill: #1D1D1B;
    }

    .st47 {
        fill: #B5B5B5;
    }

    .st48 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 9.0305, 5.644;
    }

    .st49 {
        fill: #B7B7B7;
    }

    .st50 {
        fill: #1D1D1B;
    }

    .st51 {
        fill: #B8BAB5;
    }

    .st52 {
        fill: url(#XMLID_2441_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st53 {
        fill: none;
        stroke: url(#XMLID_2870_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st54 {
        fill: #EDEDED;
    }

    .st55 {
        fill: #505154;
    }

    .st56 {
        fill: url(#XMLID_2445_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st57 {
        fill: none;
        stroke: url(#XMLID_2430_);
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .st58 {
        fill: #513B1E;
    }

    .st59 {
        fill: url(#XMLID_2448_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st60 {
        fill: #EF5A24;
    }

    .st61 {
        fill: #EF8425;
    }

    .st62 {
        fill: none;
        stroke: #969696;
        stroke-miterlimit: 10;
    }

    .st63 {
        fill: #544733;
    }

    .st64 {
        fill: none;
        stroke: #FFFFFF;
        stroke-miterlimit: 10;
    }

    .st65 {
        fill: #54D354;
    }

    .st66 {
        fill: none;
        stroke: url(#XMLID_2502_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st67 {
        fill: #555555;
    }

    .st68 {
        fill: #555D60;
    }

    .st69 {
        fill: none;
        stroke: url(#XMLID_2504_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st70 {
        fill: none;
        stroke: url(#XMLID_2505_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st71 {
        fill: #56361A;
    }

    .st72 {
        fill: #BAC8D1;
    }

    .st73 {
        fill: #F9385D;
        stroke: #23CAD9;
        stroke-width: 0.5;
        stroke-miterlimit: 10;
    }

    .st74 {
        fill: #BB8062;
    }

    .st75 {
        fill: #C7EE95;
        stroke: #23CAD9;
        stroke-width: 0.5;
        stroke-miterlimit: 10;
    }

    .st76 {
        opacity: 0.58;
        fill: #FFFFFF;
    }

    .st77 {
        fill: #2368D9;
    }

    .st78 {
        fill: #23CAD9;
    }

    .st79 {
        fill: url(#XMLID_2486_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st80 {
        fill: #F4C4A4;
    }

    .st81 {
        opacity: 0.4;
        fill: #1D1D1B;
    }

    .st82 {
        fill: url(#XMLID_2521_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st83 {
        fill: #28F7D1;
    }

    .st84 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 8.5477, 5.3423;
    }

    .st85 {
        fill: #F7F7F7;
    }

    .st86 {
        fill: #F7F8F9;
    }

    .st87 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 7.6408, 4.7755;
    }

    .st88 {
        fill: #5E5E5E;
    }

    .st89 {
        fill: #F9385D;
    }

    .st90 {
        opacity: 0.35;
        fill: #9FEDFF;
    }

    .st91 {
        fill: #C07E61;
    }

    .st92 {
        fill: #C12F52;
    }

    .st93 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 7.8706, 4.9191;
    }

    .st94 {
        fill: #C1A880;
    }

    .st95 {
        fill: #939FA3;
    }

    .st96 {
        fill: #93ADAD;
    }

    .st97 {
        fill: #943B8A;
    }

    .st98 {
        fill: #C3CDDD;
    }

    .st99 {
        fill: url(#XMLID_2512_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st100 {
        fill: #C54EB9;
    }

    .st101 {
        fill: #2B2B2B;
    }

    .st102 {
        font-family: 'FontBase-SemiBold';
    }

    .st103 {
        fill: url(#XMLID_2064_);
    }

    .st104 {
        fill: url(#XMLID_2134_);
    }

    .st105 {
        fill: url(#XMLID_2140_);
    }

    .st106 {
        fill: url(#XMLID_2143_);
    }

    .st107 {
        fill: url(#XMLID_2146_);
    }

    .st108 {
        fill: url(#XMLID_2147_);
    }

    .st109 {
        fill: url(#XMLID_2149_);
    }

    .st110 {
        fill: url(#XMLID_2150_);
    }

    .st111 {
        fill: #C7EE95;
    }

    .st112 {
        fill: #C7F2E9;
    }

    .st113 {
        fill: none;
        stroke: #042AB2;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }

    .st114 {
        fill: url(#XMLID_2238_);
    }

    .st115 {
        fill: #99845F;
    }

    .st116 {
        fill: url(#XMLID_2240_);
    }

    .st117 {
        fill: url(#XMLID_2249_);
    }

    .st118 {
        fill: url(#XMLID_2253_);
    }

    .st119 {
        fill: none;
        stroke: #28F7D1;
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st120 {
        font-family: 'FontBase-Regular';
    }

    .st121 {
        fill: url(#XMLID_2355_);
    }

    .st122 {
        fill: url(#XMLID_2356_);
    }

    .st123 {
        fill: url(#XMLID_2357_);
    }

    .st124 {
        fill: url(#XMLID_2359_);
    }

    .st125 {
        fill: url(#XMLID_2374_);
    }

    .st126 {
        fill: none;
        stroke: url(#XMLID_3090_);
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .st127 {
        fill: url(#XMLID_2425_);
    }

    .st128 {
        fill: url(#XMLID_2426_);
    }

    .st129 {
        fill: url(#XMLID_2427_);
    }

    .st130 {
        fill: url(#XMLID_2485_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st131 {
        fill: url(#XMLID_2431_);
    }

    .st132 {
        fill: url(#XMLID_2436_);
    }

    .st133 {
        fill: url(#XMLID_2437_);
    }

    .st134 {
        fill: url(#XMLID_2438_);
    }

    .st135 {
        fill: url(#XMLID_2439_);
    }

    .st136 {
        fill: none;
        stroke: url(#XMLID_2771_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st137 {
        fill: url(#XMLID_2440_);
    }

    .st138 {
        fill: url(#XMLID_2443_);
    }

    .st139 {
        fill: url(#XMLID_2444_);
    }

    .st140 {
        fill: url(#XMLID_2449_);
    }

    .st141 {
        fill: url(#XMLID_2480_);
    }

    .st142 {
        fill: url(#XMLID_2481_);
    }

    .st143 {
        fill: url(#XMLID_2482_);
    }

    .st144 {
        fill: url(#XMLID_2483_);
    }

    .st145 {
        fill: url(#XMLID_2484_);
    }

    .st146 {
        fill: url(#XMLID_2487_);
    }

    .st147 {
        fill: url(#XMLID_2488_);
    }

    .st148 {
        fill: url(#XMLID_2491_);
    }

    .st149 {
        fill: #FF3BCC;
    }

    .st150 {
        fill: url(#XMLID_2506_);
    }

    .st151 {
        fill: url(#XMLID_2507_);
    }

    .st152 {
        fill: url(#XMLID_2508_);
    }

    .st153 {
        fill: url(#XMLID_2509_);
    }

    .st154 {
        fill: url(#XMLID_2510_);
    }

    .st155 {
        fill: url(#XMLID_2511_);
    }

    .st156 {
        fill: url(#XMLID_2522_);
    }

    .st157 {
        fill: url(#XMLID_2523_);
    }

    .st158 {
        fill: url(#XMLID_2489_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st159 {
        fill: url(#XMLID_2534_);
    }

    .st160 {
        fill: url(#XMLID_2535_);
    }

    .st161 {
        fill: url(#XMLID_2536_);
    }

    .st162 {
        fill: url(#XMLID_2537_);
    }

    .st163 {
        fill: url(#XMLID_2539_);
    }

    .st164 {
        fill: #FF7676;
    }

    .st165 {
        fill: url(#XMLID_2540_);
    }

    .st166 {
        fill: url(#XMLID_2543_);
    }

    .st167 {
        fill: url(#XMLID_2544_);
    }

    .st168 {
        fill: #FF88A4;
    }

    .st169 {
        fill: url(#XMLID_2551_);
    }

    .st170 {
        fill: url(#XMLID_2553_);
    }

    .st171 {
        fill: url(#XMLID_2554_);
    }

    .st172 {
        fill: url(#XMLID_2563_);
    }

    .st173 {
        fill: url(#XMLID_2582_);
    }

    .st174 {
        fill: url(#XMLID_2585_);
    }

    .st175 {
        fill: #FFAF50;
    }

    .st176 {
        fill: #FFB236;
    }

    .st177 {
        fill: #FFC555;
    }

    .st178 {
        fill: #FFC892;
    }

    .st179 {
        fill: #FFD773;
    }

    .st180 {
        fill: #FFEB99;
    }

    .st181 {
        fill: #FFFF00;
    }

    .st182 {
        fill: #FFFFFF;
    }

    .st183 {
        fill: url(#XMLID_2542_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st184 {
        fill: url(#XMLID_62_);
    }

    .st185 {
        fill: url(#XMLID_2601_);
    }

    .st186 {
        fill: url(#XMLID_2603_);
    }

    .st187 {
        fill: url(#XMLID_2610_);
    }

    .st188 {
        fill: url(#XMLID_2624_);
    }

    .st189 {
        fill: url(#XMLID_2625_);
    }

    .st190 {
        fill: url(#XMLID_2626_);
    }

    .st191 {
        fill: url(#XMLID_2627_);
    }

    .st192 {
        fill: url(#XMLID_2628_);
    }

    .st193 {
        fill: url(#XMLID_2629_);
    }

    .st194 {
        fill: url(#XMLID_2634_);
    }

    .st195 {
        fill: url(#XMLID_2635_);
    }

    .st196 {
        fill: url(#XMLID_2641_);
    }

    .st197 {
        fill: url(#XMLID_2643_);
    }

    .st198 {
        fill: url(#XMLID_2645_);
    }

    .st199 {
        fill: url(#XMLID_2646_);
    }

    .st200 {
        fill: url(#XMLID_2647_);
    }

    .st201 {
        fill: url(#XMLID_2656_);
    }

    .st202 {
        fill: url(#XMLID_2658_);
    }

    .st203 {
        fill: url(#XMLID_2661_);
    }

    .st204 {
        fill: url(#XMLID_2677_);
    }

    .st205 {
        fill: url(#XMLID_2685_);
    }

    .st206 {
        fill: url(#XMLID_2686_);
    }

    .st207 {
        fill: url(#XMLID_2687_);
    }

    .st208 {
        fill: url(#XMLID_2690_);
    }

    .st209 {
        fill: url(#XMLID_2692_);
    }

    .st210 {
        fill: url(#XMLID_2697_);
    }

    .st211 {
        fill: url(#XMLID_2698_);
    }

    .st212 {
        fill: none;
        stroke: #F9385D;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
    }

    .st213 {
        fill: none;
        stroke: #F9385D;
        stroke-width: 3;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
    }

    .st214 {
        fill: url(#XMLID_2524_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st215 {
        fill: url(#XMLID_2525_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st216 {
        fill: url(#XMLID_2735_);
    }

    .st217 {
        fill: url(#XMLID_2766_);
    }

    .st218 {
        fill: none;
        stroke: url(#XMLID_2680_);
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .st219 {
        fill: url(#XMLID_2825_);
    }

    .st220 {
        fill: url(#XMLID_2860_);
    }

    .st221 {
        fill: url(#XMLID_2864_);
    }

    .st222 {
        fill: url(#XMLID_2867_);
    }

    .st223 {
        fill: url(#XMLID_2869_);
    }

    .st224 {
        fill: url(#XMLID_2892_);
    }

    .st225 {
        fill: url(#XMLID_2899_);
    }

    .st226 {
        fill: none;
    }

    .st227 {
        fill: none;
        stroke: url(#XMLID_2684_);
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .st228 {
        fill: url(#XMLID_2905_);
    }

    .st229 {
        fill: url(#XMLID_2907_);
    }

    .st230 {
        fill: url(#XMLID_2968_);
    }

    .st231 {
        fill: #666461;
    }

    .st232 {
        fill: none;
        stroke: url(#XMLID_2131_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st233 {
        fill: #9A5F3E;
    }

    .st234 {
        fill: none;
        stroke: url(#XMLID_2132_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st235 {
        fill: url(#XMLID_2490_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st236 {
        fill: #9BC16B;
    }

    .st237 {
        fill: #68696D;
    }

    .st238 {
        fill: none;
        stroke: url(#XMLID_2614_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st239 {
        fill: #CCCCCC;
    }

    .st240 {
        fill: #CCD8E2;
    }

    .st241 {
        fill: #303233;
    }

    .st242 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 7.8702, 4.9189;
    }

    .st243 {
        fill: #28F7D1;
        stroke: #042AB2;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }

    .st244 {
        fill: #32ADF0;
    }

    .st245 {
        fill: none;
        stroke: url(#XMLID_2141_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st246 {
        fill: none;
        stroke: #BCBCBC;
        stroke-miterlimit: 10;
    }

    .st247 {
        fill: none;
        stroke: url(#XMLID_2144_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st248 {
        fill: #353535;
    }

    .st249 {
        fill: #353638;
    }

    .st250 {
        fill: url(#XMLID_2541_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st251 {
        fill: url(#XMLID_2545_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st252 {
        fill: none;
        stroke: url(#XMLID_2805_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st253 {
        fill: url(#XMLID_2546_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st254 {
        fill: #003449;
    }

    .st255 {
        fill: #004263;
    }

    .st256 {
        fill: #006384;
    }

    .st257 {
        fill: #006937;
    }

    .st258 {
        fill: #008FB6;
    }

    .st259 {
        fill: none;
        stroke: #042AB2;
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st260 {
        fill: #020202;
    }

    .st261 {
        fill: #D0D0D0;
    }

    .st262 {
        fill: none;
        stroke: #2368D9;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }

    .st263 {
        fill: #D29472;
    }

    .st264 {
        fill: #042AB2;
    }

    .st265 {
        fill: none;
        stroke: url(#XMLID_2779_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st266 {
        fill: url(#XMLID_107_);
    }

    .st267 {
        fill: url(#XMLID_109_);
    }

    .st268 {
        fill: url(#XMLID_110_);
    }

    .st269 {
        fill: url(#XMLID_112_);
    }

    .st270 {
        fill: url(#XMLID_113_);
    }

    .st271 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 8.7526, 5.4704;
    }

    .st272 {
        fill: #3A2914;
    }

    .st273 {
        font-size: 17;
    }

    .st274 {
        fill: url(#XMLID_3022_);
    }

    .st275 {
        fill: url(#XMLID_3024_);
    }

    .st276 {
        fill: url(#XMLID_3042_);
    }

    .st277 {
        fill: url(#XMLID_3043_);
    }

    .st278 {
        fill: url(#XMLID_3045_);
    }

    .st279 {
        fill: url(#XMLID_3046_);
    }

    .st280 {
        fill: url(#XMLID_3048_);
    }

    .st281 {
        fill: url(#XMLID_3049_);
    }

    .st282 {
        fill: url(#XMLID_3050_);
    }

    .st283 {
        fill: url(#XMLID_3055_);
    }

    .st284 {
        fill: url(#XMLID_3056_);
    }

    .st285 {
        fill: url(#XMLID_3062_);
    }

    .st286 {
        fill: url(#XMLID_3063_);
    }

    .st287 {
        fill: url(#XMLID_3064_);
    }

    .st288 {
        fill: url(#XMLID_3066_);
    }

    .st289 {
        fill: url(#XMLID_3067_);
    }

    .st290 {
        fill: url(#XMLID_3078_);
    }

    .st291 {
        fill: url(#XMLID_3082_);
    }

    .st292 {
        fill: url(#XMLID_3083_);
    }

    .st293 {
        fill: url(#XMLID_3084_);
    }

    .st294 {
        fill: url(#XMLID_3087_);
    }

    .st295 {
        fill: url(#XMLID_3088_);
    }

    .st296 {
        fill: url(#XMLID_3089_);
    }

    .st297 {
        fill: url(#XMLID_3092_);
    }

    .st298 {
        fill: none;
        stroke: #686868;
        stroke-miterlimit: 10;
    }

    .st299 {
        fill: url(#XMLID_454_);
    }

    .st300 {
        fill: #3D3D3D;
    }

    .st301 {
        fill: #D82A53;
    }

    .st302 {
        mask: url(#XMLID_2248_);
    }

    .st303 {
        mask: url(#XMLID_2254_);
    }

    .st304 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 7.289, 4.5557;
    }

    .st305 {
        fill: #707070;
    }

    .st306 {
        fill: none;
        stroke: url(#XMLID_2642_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st307 {
        mask: url(#XMLID_2358_);
    }

    .st308 {
        mask: url(#XMLID_2375_);
    }

    .st309 {
        fill: none;
        stroke: url(#XMLID_2644_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st310 {
        clip-path: url(#XMLID_2501_);
    }

    .st311 {
        clip-path: url(#XMLID_2503_);
    }

    .st312 {
        fill: none;
        stroke: url(#XMLID_2648_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st313 {
        fill: none;
        stroke: url(#XMLID_2649_);
        stroke-width: 6;
        stroke-miterlimit: 10;
    }

    .st314 {
        clip-path: url(#XMLID_2674_);
    }

    .st315 {
        clip-path: url(#XMLID_2678_);
    }

    .st316 {
        clip-path: url(#XMLID_2691_);
    }

    .st317 {
        fill: #A2A599;
    }

    .st318 {
        fill: #A2A7AC;
    }

    .st319 {
        fill: none;
        stroke: #28F7D1;
        stroke-miterlimit: 10;
    }

    .st320 {
        fill: #A4704C;
    }

    .st321 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 8.339, 5.2119;
    }

    .st322 {
        fill: none;
        stroke: url(#XMLID_3039_);
        stroke-width: 5;
        stroke-miterlimit: 10;
    }

    .st323 {
        fill: url(#XMLID_2606_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st324 {
        fill: url(#XMLID_2608_);
        stroke: #383838;
        stroke-miterlimit: 10;
    }

    .st325 {
        fill: #DA9571;
    }

    .st326 {
        fill: #DB6812;
    }

    .st327 {
        fill: #0D1F30;
    }

    .st328 {
        fill: none;
        stroke: #545454;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }

    .st329 {
        fill: #A8A8A8;
    }

    .st330 {
        fill: #DCFFF8;
    }

    .st331 {
        fill: none;
        stroke: #23CAD9;
        stroke-miterlimit: 10;
    }

    .st332 {
        fill: none;
        stroke: url(#XMLID_2500_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st333 {
        fill: #0F0F0F;
    }

    .st334 {
        fill: #0F4B63;
    }

    .st335 {
        fill: #DDE5ED;
    }

    .st336 {
        fill: url(#XMLID_2597_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st337 {
        fill: #424242;
    }

    .st338 {
        fill: url(#XMLID_2632_);
        stroke: #232323;
        stroke-miterlimit: 10;
    }

    .st339 {
        fill: none;
        stroke: #32ADF0;
        stroke-width: 2;
        stroke-miterlimit: 10;
    }

    .st340 {
        filter: url(#Adobe_OpacityMaskFilter_1_);
    }

    .st341 {
        filter: url(#Adobe_OpacityMaskFilter_2_);
    }

    .st342 {
        filter: url(#Adobe_OpacityMaskFilter_3_);
    }

    .st343 {
        opacity: 0.51;
        fill: #FFFFFF;
        enable-background: new;
    }

    .st344 {
        fill: #444444;
    }

    .st345 {
        fill: none;
        stroke: url(#XMLID_2473_);
        stroke-width: 2;
        stroke-miterlimit: 10;
    }
</style>